import { z } from "zod";

import { productWithVariants } from "./component";

export const bundleDiscountTypeSchema = z
  .enum(["percentageOff", "fixedAmount"])
  .describe("BundleDiscountType");

export const bundleDiscountSchema = z
  .object({
    type: bundleDiscountTypeSchema,
    value: z.number(),
  })
  .describe("BundleDiscount");

export const bundleDiscountThresholdSchema = z
  .object({
    quantity: z.number(),
    discount: bundleDiscountSchema,
  })
  .describe("BundleDiscountThreshold");

export const bundleConfigSchema = z
  .object({
    id: z.string(),
    isTiered: z.boolean().optional(),
    allowMultipleOfSameItem: z.boolean(),
    targetType: z.enum(["products", "variants"]),
    productsWithVariants: z.array(productWithVariants),
    thresholds: z.array(bundleDiscountThresholdSchema),
  })
  .describe("BundleConfig");

export const shopBundleConfigsSchema = z
  .record(z.string(), bundleConfigSchema)
  .describe("ShopBundleConfigs");
